import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { useLiff } from './hooks/useLiff'
import { NotInLinePage } from './pages/NotInLinePage'
import { ConsentPage } from './pages/ConsentPage'
import { OnboardingPage } from './pages/OnboardingPage'
import { PendingPage } from './pages/PendingPage'
import { FlowAPage } from './pages/FlowAPage'
import { ChecklistPage } from './pages/ChecklistPage'
import './index.css'

function App() {
  const { profile, isLoading, isInClient, isLoggedIn, error } = useLiff()

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-gray-50">
        <div className="text-gray-400">กำลังโหลด...</div>
      </div>
    )
  }

  // Not in LINE and not logged in
  if (!isLoggedIn && !isInClient) {
    return <NotInLinePage />
  }

  if (error || !profile) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-gray-50 px-4">
        <div className="text-center text-sm text-red-500">
          {error || 'ไม่สามารถโหลดข้อมูลได้'}
        </div>
      </div>
    )
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<ConsentPage profile={profile} />} />
        <Route path="/onboarding" element={<OnboardingPage profile={profile} />} />
        <Route path="/pending" element={<PendingPage />} />
        <Route path="/flow-a" element={<FlowAPage profile={profile} />} />
        <Route path="/checklist" element={<ChecklistPage profile={profile} />} />
      </Routes>
    </BrowserRouter>
  )
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
